import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import {gql} from "@irati/utils/gql"

export const orderAuditLogsQuery = gql`
  query orderAuditLogs($order_id: ID!) {
    orderAuditLogs(order_id: $order_id) {
      audit_logs {
        name
        email
        timestamp
        changed_fields {
          field_name
          previous_value
          new_value
        }
      }
    }
  }
`

export const getOrderAuditLogsQueryKey = getQueryNames(orderAuditLogsQuery)[0]
